import React from "react";
import { Link } from "react-router-dom";
import { Box, Tooltip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

import "../styles/index.scss";

function ProjectCard({ project }) {
  const renderDesktopFlipCard = () => {
    return (
      <Box className="flipCard">
        <Box className="flipCardContent">
          <Box className="front">
            <img className="cover" src={project.cover} alt={project.name} />
            <Box className="title">{project.name}</Box>
          </Box>
          <Box className="back">
            <Box
              className="banner"
              component={Link}
              to={{
                pathname: project.path,
                state: { project: project },
              }}
            >
              {project.name}
            </Box>
            <Box className="subtitle" mt={1}>
              {project.description}
            </Box>
            <Box display="flex" flexDirection="row" mt={10}>
              <Tooltip placement="top" title="GitHub">
                <a target="_blank" rel="noreferrer" href={project.github}>
                  <FontAwesomeIcon
                    className={`icon ${
                      project.github ? "enabled" : "disabled"
                    }`}
                    icon={faGithub}
                  />
                </a>
              </Tooltip>
              <Tooltip placement="top" title="Demo">
                <a target="_blank" rel="noreferrer" href={project.demo}>
                  <FontAwesomeIcon
                    className={`icon ${project.demo ? "enabled" : "disabled"}`}
                    icon={faExternalLinkAlt}
                  />
                </a>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };
  return <Box className="projectCard">{renderDesktopFlipCard()}</Box>;
}

export default ProjectCard;
